import { type StatItem } from "@/components/design-system/StatCard/StatCard";

export const stats: readonly StatItem[] = [
  {
    value: "82%",
    description:
      "of Gen Z and millennials already use AI for financial guidance. The question isn't if — it's who shows up when they ask.",
  },
  {
    value: "<10%",
    description:
      "of members engage with traditional wellness programs. Static portals educate — they don't personalize or get smarter with each interaction.",
  },
  {
    value: "75%",
    description:
      "of people who use AI for financial questions say it lets them ask things they're too embarrassed to ask a person.",
  },
  {
    value: "41%",
    description:
      "of Gen Z and millennials would trust AI to manage their finances — nearly 3x the rate of boomers.",
  },
];
